// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","slidein":"Message_slidein__F8YXD","main":"Message_main__ziCdH","closeButton":"Message_closeButton__b-6Ej"};